import { render, staticRenderFns } from "./CreateLaporanUmpd.vue?vue&type=template&id=5ca42577&"
import script from "./CreateLaporanUmpd.vue?vue&type=script&lang=js&"
export * from "./CreateLaporanUmpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports